import restrictedAxiosInstance from "../config/restrictedAxiosInstance"; // Import the custom Axios instance
import { RESTRICTEDSERVERENDPOINTS } from "../config/restrictedApiConfig"; // Import the upload API URLs

interface UploadResponse {
  end: number;
  responseBody: { message: string; newFileName: string };
}

export const restrictedUploadChunk = async (
  file: File,
  start: number,
  documentClassification: any,
  gpid: any,
  fileId?: string,
  chunkList?: string[]
) => {
  const chunkSize = 5120 * 1024; // 5 MB
  const end = Math.min(start + chunkSize, file.size);
  const chunk = file.slice(start, end);
  const formData = new FormData();
  formData.append("file", chunk, file.name);
  formData.append("start", start.toString());
  formData.append("total", file.size.toString());
  formData.append("filename", file.name);
  formData.append("confidentiality", documentClassification); // Add confidentiality
  formData.append("gpid", gpid); // Add gpid
  chunkList?.forEach((chunk) => {
    formData.append(`chunkNames[]`, chunk);
  });

  try {
    // Send the chunk using axios instance
    const response = await restrictedAxiosInstance.post(
      RESTRICTEDSERVERENDPOINTS.restrictedUpload,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set content type to multipart
        },
      }
    );

    // Check if response is okay
    if (response.status !== 200) {
      throw new Error(`Upload failed with status ${response.status}`);
    }

    // Return the end position and the response data
    return { end, responseBody: response.data };
  } catch (error) {
    console.error("Upload error:", error);
    throw error; // Re-throw the error for handling in the calling function
  }
};
